// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `i.chevron-down {
    display: inline-block;
    border-right: 2px solid;
    border-bottom: 2px solid;
    width: 8px; height: 8px;
    transform: rotate(45deg) translateY(-12%) translateX(-12%);
}

i.chevron-left {
    display: inline-block;
    border-right: 2px solid;
    border-bottom: 2px solid;
    width: 8px; height: 8px;
    transform: rotate(135deg) translateY(-12%) translateX(-12%);
}

i.chevron-up {
    display: inline-block;
    border-right: 2px solid;
    border-bottom: 2px solid;
    width: 8px; height: 8px;
    transform: rotate(225deg) translateY(-12%) translateX(-12%);
}

i.chevron-right {
    display: inline-block;
    border-right: 2px solid;
    border-bottom: 2px solid;
    width: 8px; height: 8px;
    transform: rotate(315deg) translateY(-12%) translateX(-12%);
}`, "",{"version":3,"sources":["webpack://./src/css/icon.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,UAAU,EAAE,WAAW;IACvB,0DAA0D;AAC9D;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,UAAU,EAAE,WAAW;IACvB,2DAA2D;AAC/D;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,UAAU,EAAE,WAAW;IACvB,2DAA2D;AAC/D;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,UAAU,EAAE,WAAW;IACvB,2DAA2D;AAC/D","sourcesContent":["i.chevron-down {\n    display: inline-block;\n    border-right: 2px solid;\n    border-bottom: 2px solid;\n    width: 8px; height: 8px;\n    transform: rotate(45deg) translateY(-12%) translateX(-12%);\n}\n\ni.chevron-left {\n    display: inline-block;\n    border-right: 2px solid;\n    border-bottom: 2px solid;\n    width: 8px; height: 8px;\n    transform: rotate(135deg) translateY(-12%) translateX(-12%);\n}\n\ni.chevron-up {\n    display: inline-block;\n    border-right: 2px solid;\n    border-bottom: 2px solid;\n    width: 8px; height: 8px;\n    transform: rotate(225deg) translateY(-12%) translateX(-12%);\n}\n\ni.chevron-right {\n    display: inline-block;\n    border-right: 2px solid;\n    border-bottom: 2px solid;\n    width: 8px; height: 8px;\n    transform: rotate(315deg) translateY(-12%) translateX(-12%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
